import { cn } from '~/lib/utils';

interface TestimonialCardProps {
  quote: string;
  author: string;
  role: string;
  company: string;
  avatarSrc?: string;
  textSize?: 'sm' | 'md' | 'lg';
}

export function TestimonialCard({
  quote,
  author,
  role,
  company,
  avatarSrc,
  textSize = "sm",
}: TestimonialCardProps) {
  return (
    <div className="my-12 relative overflow-hidden rounded-2xl border border-black/5 bg-gray-50 p-8 dark:bg-white/5 md:p-10">
      <div className="absolute top-4 left-6 text-6xl text-black/5 font-serif leading-none dark:text-white/5 select-none">
        &ldquo;
      </div>
      <blockquote
        className={cn(
          "relative z-10 mb-6 font-medium leading-relaxed text-black dark:text-white",
          textSize === "sm"
            ? "text-base"
            : textSize === "md"
            ? "text-lg"
            : "text-xl md:text-2xl"
        )}
      >
        "{quote}"
      </blockquote>
      <div className="relative z-10 flex items-center gap-4">
        {avatarSrc && (
          <img
            src={avatarSrc}
            alt={author}
            className="h-12 w-12 rounded-full object-cover border border-black/10 dark:border-white/10"
          />
        )}
        <div>
          <div className="font-semibold text-black dark:text-white">
            {author}
          </div>
          <div className="text-sm text-black/60 dark:text-white/60">
            {role}, {company}
          </div>
        </div>
      </div>
    </div>
  );
}

